export default __webpack_public_path__ + "static/media/24-min.33babad4.jpg";